import { CForm, CFormInput, CFormLabel, CFormSelect } from '@coreui/react-pro'
import PropTypes from 'prop-types'
import React from 'react'
import longLogo from '../../assets/images/brand/swiftcampus_logo.png'
function SchoolSearchForm({
  getSchoolsFromSchoolCode,
  schoolCodeResults,
  setselectedSchoolDetails,
}) {
  const onSchoolCodeChange = (value) => {
    getSchoolsFromSchoolCode(value)
  }
  return (
    <>
      <CForm className="school-search-form rounded">
        <div className="w-100 text-center mb-3">
          <img src={longLogo} alt="" className='w-75'/>
        </div>
        <CFormInput
          name="school-code"
          id="school-code"
          onChange={(e) => onSchoolCodeChange(e.target.value)}
          placeholder="Enter your School Code Here..."
        />
        {schoolCodeResults.length ? (
          <div className="school-search-results hidden-scrollbar mt-2">
            <CFormLabel className="fs-3 text-dark">Select a School</CFormLabel>
            {schoolCodeResults.map((data, index) => {
              return (
                <div
                  key={index}
                  onClick={() => setselectedSchoolDetails(data)}
                  className="school_name"
                >
                  {data.School_Name}
                </div>
              )
            })}
          </div>
        ) : <></>}
      </CForm>
    </>
  )
}
SchoolSearchForm.propTypes = {
  getSchoolsFromSchoolCode: PropTypes.func.isRequired,
  setselectedSchoolDetails: PropTypes.func.isRequired,
  schoolCodeResults: PropTypes.array.isRequired,
}
export default SchoolSearchForm
